import { EllipsisVertical } from 'lucide-react';
import React from 'react';
import { Button } from '@components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@components/ui/dropdown-menu';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ContextMenuOption<T = any> {
    label: string | ((value: T) => string);
    value?: T;
    name?: string;
    divider?: boolean;
    hidden?(value: T): boolean;
    action(value: T): void;
}

interface ContextMenuProps {
    children?: React.ReactNode;
    items: ContextMenuOption[];
}

export function ContextMenu(props: ContextMenuProps) {
    const items = props.items.filter((item) =>
        item.hidden ? !item.hidden(item.value) : true
    );

    if (items.length === 0) {
        return null;
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
                {props.children ?? (
                    <Button variant="ghost" size="icon-sm" aria-label="Actions">
                        <EllipsisVertical />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                onClick={(e) => e.stopPropagation()}
            >
                {items.map((item, i) => (
                    <React.Fragment key={String(i)}>
                        {item.divider && i > 0 && <DropdownMenuSeparator />}
                        <DropdownMenuItem
                            onSelect={() => item.action(item.value)}
                        >
                            {typeof item.label === 'string'
                                ? item.label
                                : item.label(item.value)}
                        </DropdownMenuItem>
                    </React.Fragment>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
